export interface UploadProgress { loaded: number; total: number }

/** Browser upload bytes only; completion does not imply server processing is done. */
export function uploadJson(url: string, body: string, headers: Record<string, string>, signal: AbortSignal,
  onProgress: (progress: UploadProgress) => void): Promise<Pick<Response, 'ok' | 'status' | 'text'>> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const total = new Blob([body]).size;
    const cleanup = () => signal.removeEventListener('abort', abort);
    const abort = () => { xhr.abort(); cleanup(); reject(new DOMException('Request aborted', 'AbortError')); };
    if (signal.aborted) { abort(); return; }
    xhr.open('POST', url);
    Object.entries(headers).forEach(([key, value]) => xhr.setRequestHeader(key, value));
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) onProgress({ loaded: event.loaded, total: event.total });
    };
    xhr.upload.onload = () => onProgress({ loaded: total, total });
    xhr.onload = () => { cleanup(); resolve({ ok: xhr.status >= 200 && xhr.status < 300,
      status: xhr.status, text: async () => xhr.responseText }); };
    xhr.onerror = () => { cleanup(); reject(new TypeError('Upload connection failed')); };
    xhr.onabort = () => { cleanup(); reject(new DOMException('Request aborted', 'AbortError')); };
    signal.addEventListener('abort', abort);
    onProgress({ loaded: 0, total });
    xhr.send(body);
  });
}
